var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBlockAdornment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 455 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455 0c-98.841.1-197.433 9.926-294.349 29.336a166.864 166.864 0 00-106.94 71.739A169.86 169.86 0 0028.6 161.931 1497.523 1497.523 0 00.001 455H439c8.837 0 16-7.163 16-16V0z",
    fill: "currentColor"
  })));
}
export default SvgMainBlockAdornment;